import React from "react";
import './ColorSelectionCard.css';
import AccountInfoScreenCard from "./AccountInfoScreenCard";
import LoadingDisplay from "components/reusable/LoadingDisplay";

class ColorSelectionCard extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            allowableColors: null,
            isEditing: false,
            disableChangeColorButton: false,
            userColor: this.props.userInfo.color,
            selectedColorName: null,
            selectedColor: null,
        };

        this.setSelection = this.setSelection.bind(this);

    }


    setSelectedColorOnLoad(){
        let acceptableUserColor = Object.keys(this.props.allowableColors).find(key =>{
            return this.props.allowableColors[key] === this.state.userColor
        });
        if(!acceptableUserColor){
            acceptableUserColor = Object.keys(this.props.allowableColors)[0];
        }
        this.setState({
            selectedColorName: acceptableUserColor,
            selectedColor: this.props.allowableColors[acceptableUserColor]
        })
    }

    setSelection(event){
        let selectedColorName = event.currentTarget.dataset.name;
        this.setState({
            selectedColorName: selectedColorName,
            selectedColor: this.props.allowableColors[selectedColorName]
        })
        this.props.updateSetting({color: this.props.allowableColors[selectedColorName]});
    }
    
    get actions(){
        if(this.props.mode === 'edit'){
            if(this.props.allowableColors){
                
                let colorOptions = Object.keys(this.props.allowableColors).map(colorKey => {
                    let className = 'color-option';
                    if(this.state.selectedColorName === colorKey){
                        className += ' selected';
                    }
                    return (<div className={className} data-name={colorKey} key={colorKey} style={{backgroundColor: this.props.allowableColors[colorKey]}} onClick={this.setSelection}></div>)
                })

                return (
                    <div className="color-selector-container">
                        <div className="color-selector-options">
                            {colorOptions}
                        </div>
                    </div>
                )

            }else{
                return (<LoadingDisplay isLoading={true}></LoadingDisplay>);
            }
        }else if(this.props.userInfo?.username){
            return (
                <div className="color-sample" style={{backgroundColor: this.props.userInfo.color}}>{this.props.userInfo.username.substring(0,1)}</div>
            )
            
        }
    }

    get content(){
        if(this.props.mode === 'edit'){
            if(this.props.allowableColors && this.props.userInfo?.username){
                return (
                    <div className="color-sample-container">
                        <div className="color-sample-label-text">Preview:</div>
                        <div className="color-sample" style={{backgroundColor: this.props.userInfo.color}}>{this.props.userInfo.username.substring(0,1)}</div>
                    </div>
                )
            }else{
                return (<LoadingDisplay isLoading={true}></LoadingDisplay>);
            }
        }
    }


    getAccountInfoScreen(){

        return (
            <>

                <AccountInfoScreenCard 
                    emphasis={this.props.mode === 'edit'}
                    label="Account Color" 
                    content={this.content}
                    actions={this.actions}
                ></AccountInfoScreenCard>
                
            </>

        );
    }

    render(){

        return (
            <>
                {this.getAccountInfoScreen()}                
            </>
        );
    }
}

export default ColorSelectionCard;
